module.exports = __webpack_public_path__ + "img/listItem3.cd2d52fe.png";